import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { integer } from 'vuelidate/lib/validators';

@Component
export default class NumberInputMixin extends Vue {
  @Prop({default: 0}) 
  value: number;

  @Prop({default: null}) 
  min: number;

  @Prop({default: null}) 
  max: number;

  @Emit('input')
  onInput(value: number) {}

  inputValue: string = '0';

  get validator(): Function  {
    return integer;
  }

  prepareInnerValue(value: string) {
    return value;
  }

  setInnerValue() {
    const inputValue = this.prepareInnerValue(this.inputValue);

    if(this.validator(inputValue)) {
      this.innerValue = +inputValue;
    } else {
      this.updateInputValue();
    }
  }

  pValue: number = 0;

  get innerValue() {
    return this.pValue;
  }

  set innerValue(value: number) {
    if(this.min !== null && value < this.min) {
      this.pValue = this.min;
    } else if(this.max !== null && value > this.max) {
      this.pValue = this.max;
    } else {
      this.pValue = value;
    }

    this.updateInputValue();
    
    this.onInput(this.pValue);
  }

  @Watch('value', {immediate: true})
  onValueChanged(value: number) {
    this.innerValue = value;
  }

  @Watch('innerValue', {immediate: true})
  onInnerValueChaged(value: number) {
    this.updateInputValue();
  }

  updateInputValue() {
    this.inputValue = this.innerValue + '';
  }
}
